/** Draft FILTERS + 실서버 카테고리 라우트 */
export const HOME_CATEGORY_FILTERS = [
  { id: 'sleep', labelKey: 'homepage.filters.sleep', icon: 'bedtime', color: 'indigo' },
  { id: 'focus', labelKey: 'homepage.filters.focus', icon: 'lightbulb', color: 'cyan' },
  { id: 'stress', labelKey: 'homepage.filters.stress', icon: 'sunny', color: 'amber' },
  { id: 'mind', labelKey: 'homepage.filters.mind', icon: 'psychology', color: 'purple' },
  { id: 'field', labelKey: 'homepage.filters.field', icon: 'landscape', color: 'emerald' },
  { id: 'diet', labelKey: 'homepage.filters.diet', icon: 'monitor_weight', color: 'rose' },
] as const;

export const FILTER_ICON_COLORS: Record<string, string> = {
  indigo: 'text-indigo-300',
  cyan: 'text-cyan-300',
  amber: 'text-amber-300',
  purple: 'text-purple-300',
  emerald: 'text-emerald-300',
  rose: 'text-rose-300',
};

export const HOME_CATEGORY_ROUTES: Record<string, string> = {
  sleep: '/app/category/sleep',
  focus: '/app/category/concentration',
  stress: '/app/category/stress',
  mind: '/app/category/minit_miracle',
  field: '/app/category/experience',
  diet: '/app/category/diet',
};
